class Requests {

	constructor (Ramda) {
		const { curry } = Ramda

		const getWorkplans = curry((service, user) => {
			return service.getTeacherWorkplans.request({ teacherId: user.teacherId }).$promise.then((dataReturn) => {
				return dataReturn.status ? dataReturn.data : 'error in communication'
			})
		})
		const getSummanyProgress = curry((service, id) => {
			return service.getSummanyProgress.post({ teacherId: id }).$promise.then((dataReturn) => {
				return dataReturn.status ? dataReturn : 'error in communication'
			})
		})

		const setEndExecutionHeader = curry((config, user, data) => {
			return {
				teacherId                    : user.teacherId,
				workplanId                   : user.workplanId,
				userId                       : user.id,
				stageId                      : config.workplanIdStages.execution,
				stageName                    : config.workplanStagesNames.execution,
				data                         : data.submodulesProgress,
				totalHours                   : data.totalHoursAllSubmodules,
				totalHoursExecution          : data.totalHoursExecutedAllSubmodules,
				isExistActiWitOutHourExecuted: data.isExistActiWitOutHourExecuted,
				minHours                     : data.minHours,
				maxHours                     : data.maxHours,
				isPlanning                   : 0,
				isMinHoursExecuted           : data.isMinHoursExecuted,
				isMaxHoursExecuted           : data.isMaxHoursExecuted,
				isControlHoursActive         : data.isControlHoursActive,
			}
		})

		const setEndAprovalHeader = curry((config, user, currentStage, data) => {
			return {
				teacherId   : user.teacherId,
				workplanId  : user.workplanId,
				userId      : user.id,
				textStage   : config.workplanStagesNames.approval,
				currentStage: currentStage,
				count       : data.toApprove,
				toReviewed  : data.noTouched,
				allAct      : data.allAct,
			}
		})

		const setEndEvaluationHeader = curry((config, user, currentStage, noTouched) => {
			return {
				teacherId   : user.teacherId,
				workplanId  : user.workplanId,
				userId      : user.id,
				textStage   : config.workplanStagesNames.evaluation,
				currentStage: currentStage,
				toReviewed  : noTouched,
			}
		})

		const setEndReviewExecutionHeader = curry((config, user, currentStage, noTouched) => {
			return {
				teacherId   : user.teacherId,
				workplanId  : user.workplanId,
				userId      : user.id,
				textStage   : config.workplanStagesNames.reviewExecution,
				currentStage: currentStage,
				toReviewed  : noTouched,
			}
		})

		const getReviewList = curry((teacherId, workplanId, service, workplan, module) => {
			let header = {
				teacherId : teacherId,
				workplanId: workplan ? Number(workplan) : workplanId,
			}

			switch (module) {

			case 'teaching':
				return service.getReviewListData.teaching(header).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'academicManagement':
				return service.getReviewListData.academicManagement(header).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'consolidation':
				return service.getReviewListData.consolidation(header).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'investigation':
				return service.getReviewListData.investigation(header).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'extentionAndVisibility':
				return service.getReviewListData.extentionAndVisibility(header).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			
			}
		})

		const setDetailsHeader = curry((lib, activity) => {
			return lib.isSubjectType(activity) ? {
				teacherId   : activity.teacherId,
				asignatureId: activity.asignatureId,
				workplanId  : activity.workplanId,
			} : activity.workplanTeacherActivityId ? {
				workplanTeacherActivityId: activity.workplanTeacherActivityId,
				activityTypeId           : activity.activityTypeId,
			} : {
				workplanTeacherActivityId: activity.workplanTeacherActivityId,
				activityTypeId           : activity.activityTypeId,
				workplanTeacherId        : activity.workplanTeacherId,
				activityId               : activity.activityId,
				teacherId                : activity.teacherId,
				workplanId               : activity.workplanId,
				workplanTeacherChargeId  : activity.workplanTeacherChargeId,
				description              : activity.description,
				hours                    : 0,
				isFeedbackActivity       : activity.isFeedbackActivity,
				percentage               : 0,
				countActivity            : 0,
				userId                   : activity.userId,
			}
		})

		const normalizeActivity = curry((setNullHours, activity) => {
			activity.forEach((children) => {
				children.name = children.itemActivityName
				delete children.itemActivityName
				children.description = children.detail
				delete children.detail
			})

			return setNullHours(activity)
		})

		const formatSubjectActivity = curry((normalizeActivity, response) => {
			let format = {
				data    : response.data.header[0],
				planning: normalizeActivity(response.data.activitiesPlanning),
				teaching: normalizeActivity(response.data.activitiesTeachers),
			}

			format.planning.type = 'planning'
			format.planning.totalPlannedHours = response.dataSum.countHoursPlannedPlanning
			format.planning.totalExecutedHours = response.dataSum.countHoursExecutedPlanning

			format.teaching.type = 'teaching'
			format.teaching.totalPlannedHours = response.dataSum.countHoursPlannedTeacher
			format.teaching.totalExecutedHours = response.dataSum.countHoursExecutedTeacher

			return format
		})

		const routeDetails = curry((lib, setNullHours, setStudentAttentionData, formatSubjectActivity, module, activity, response) => {
			switch (module) {

			case 'teaching':
				if (lib.isSubjectType(activity)) {
					return formatSubjectActivity(response)
				} else if (lib.isStudentAttentionType(activity)) {
					return {
						data: setStudentAttentionData(setNullHours([ response.data ])[0]),
					}
				} else {
					return {
						data         : response.data,
						otherActivity: setNullHours([ response.data ]),
					}
				}
			case 'academicManagement':
				return { data: response }
			case 'consolidation':
				return { data: response }
			case 'investigation':
				if (lib.isProductsType(activity) || lib.isProjectsType(activity)) {
					return {
						data    : response.parent,
						children: response.childs,
					}
				}

				return { data: response }
			case 'extentionAndVisibility':
				if (lib.isExtensionProjectsType(activity) || lib.isCrossExtensionProjectsType(activity)) {
					return {
						data    : response.parent,
						children: response.childs,
					}
				}

				return {
					data: response,
				}
			
			}
		})

		const getActivityDetails = curry((service, setHeader, module, activity) => {
			switch (module) {

			case 'teaching':
				return service.getReviewDetails.teaching(setHeader(activity)).$promise.then((response) => {
					return response.status ? response : 'error in communication'
				})
			case 'academicManagement':
				return service.getReviewDetails.academicManagement(setHeader(activity)).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'consolidation':
				return service.getReviewDetails.consolidation(setHeader(activity)).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'investigation':
				return service.getReviewDetails.investigation(setHeader(activity)).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			case 'extentionAndVisibility':
				return service.getReviewDetails.extentionAndVisibility(setHeader(activity)).$promise.then((response) => {
					return response.status ? response.data : 'error in communication'
				})
			
			}
		})

		function setNullHours (arr) {
			arr.forEach((element) => {
				if (!element.hoursPlanned) {
					element.hoursPlanned = 0
				}
				/* if (!element.hoursExecuted) {
          element.hoursExecuted = 0
        } */
			})

			return arr
		}

		function setStudentAttentionData (data) {
			let splits = [ 'periodsNames', 'daysNames' ]
			let hours = [ 'startHours', 'endHours' ]

			if (data[splits[0]] && data[splits[1]]) {
				data.periodsNames = data[splits[0]].split(',').join(', ')
				data.daysNames = data[splits[1]].split(',').join(', ')
			}

			if (data[hours[0]] && data[hours[1]]) {
				data.periodsNames = data[hours[0]].substr(0, 5)
				data.daysNames = data[hours[1]].substr(0, 5)
			}

			data.hoursExecuted = data.hoursExecutedDetails
			delete data.hoursExecutedDetails
			data.hoursPlanned = data.hoursPlannedDetails
			delete data.hoursPlannedDetails

			return data
		}

		function submoduleItemRequired (header) {
			let validateSubmodules = {
				teaching          : false,
				academicManagement: false,
			}

			let submodule = header.submodules

			for (var i in submodule) {
				if (submodule[i].submoduleId === header.teaching) { validateSubmodules.teaching = true }

				if (submodule[i].submoduleId === header.academicManagement) {
					validateSubmodules.academicManagement = true
				}
			}

			return validateSubmodules
		}

		function validateItems (header) {
			let showModal = false

			if (header.submodule.teaching) {
				if (header.itemList.length > 0 || header.itemListOtherAct.length > 0) {
					showModal = true
				}
			}

			if (header.submodule.academicManagement) {
				if (header.itemListOtherActAM.length > 0) {
					showModal = true
				}
			}

			return showModal
		}

		function showModalItemRequiredEndPlanning (WorkPlanModalSrv, header) {
			let data = {
				itemOthersActivityRequired: header.itemListOtherAct,
				itemAssignatures          : header.itemList,
				itemListOtherActAM        : header.itemListOtherActAM,
			}

			WorkPlanModalSrv.setVariable(data)
			WorkPlanModalSrv.itemRequiredTeaching()
		}

		function showModalItemRequiredEndExecution (WorkPlanModalSrv, header) {
			let data = {
				itemActivities: header,
			}

			WorkPlanModalSrv.setVariable(data)
			WorkPlanModalSrv.itemRequiredExecution()
		}

		function getItemsRequiredList (WorkPlanSrv, header) {
			let data = {
				itemListOtherAct  : [],
				itemListOtherActAM: [],
				itemList          : [],
			}

			return WorkPlanSrv.getItemRequiredTeaching.getList(header).$promise.then(function (dataReturn) {
				if (dataReturn.status) {
					data.itemListOtherAct = dataReturn.otherActivities
					data.itemListOtherActAM = dataReturn.otherActivitiesAM
					var activities = []

					for (var i in dataReturn.assignatures) {
						for (var j in dataReturn.activities) {
							if (dataReturn.assignatures[i].id_assignature === dataReturn.activities[j].id_assignature) {
								activities.push(dataReturn.activities[j])
							}
						}
						data.itemList.push({
							assignatureName: dataReturn.assignatures[i].assignatureName,
							assignatureId  : dataReturn.assignatures[i].id_assignature,
							showChilds     : false,
							itemList       : activities,
						})
						activities = []
					}

					return data
				} else {
					console.log('Comunications problem with the server')
				}
			}, function (data) {
				console.log(data)
			})
		}

		function showModalEndPlannig (WorkPlanSrv, WorkPlanModalSrv, post, $mdDialog) {
			let header = {}

			return WorkPlanSrv.getSummanyProgress.post({ teacherId: post.teacherId }).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					header.feedback = post.feedback
					header.stageId = post.stageId
					header.teacherId = post.teacherId
					header.userId = post.userId
					header.workplanId = post.workplanId
					header.data = dataReturn.submodulesProgress
					header.totalHours = dataReturn.totalHoursAllSubmodules
					header.minHours = dataReturn.minHours
					header.maxHours = dataReturn.maxHours
					header.feedback = header.feedback
					header.isMinHoursPlanning = (dataReturn.isMinHoursPlanning == 1) ? true : false
					header.isMaxHoursPlanning = (dataReturn.isMaxHoursPlanning == 1) ? true : false
					header.isMinHoursExecuted = (dataReturn.isMinHoursExecuted == 1) ? true : false
					header.isMaxHoursExecuted = (dataReturn.isMaxHoursExecuted == 1) ? true : false
					header.isPlanning = 1
					header.isControlHoursActive = dataReturn.isControlHoursActive

					// if (header.isControlHoursActive && (header.isMinHoursPlanning || header.isMaxHoursPlanning)) {
					// showModalHoursParametrization(header, $mdDialog, WorkPlanModalSrv)
					// } else {
					getModalEndPlanning(header, WorkPlanModalSrv, $mdDialog)
					// }
				}
			})
		}

		function getModalEndPlanning (header, WorkPlanModalSrv, $mdDialog) {
			WorkPlanModalSrv.setVariable(header)

			return WorkPlanModalSrv.endPlanning().then((promise) => {
				return WorkPlanModalSrv.getVariable()
			})
		}

		function showModalHoursParametrization (header, $mdDialog, WorkPlanModalSrv) {
			$mdDialog.show({
				controller: [ '$scope', '$mdDialog', function($scope, $mdDialog) {
					$scope.data = header
					$scope.close = function () {
						$mdDialog.hide()

						return getModalEndPlanning(header, WorkPlanModalSrv)
					}
				} ],
				template           : require('../workplan/partials/modals/hoursParametrizationModal.html'),
				clickOutsideToClose: false,
			})
		}

		// VALIDATIONS SIGNATURE
		return {
			getWorkplans: getWorkplans,

			getSummanyProgress         : getSummanyProgress,
			setEndExecutionHeader      : setEndExecutionHeader,
			setEndAprovalHeader        : setEndAprovalHeader,
			setEndEvaluationHeader     : setEndEvaluationHeader,
			setEndReviewExecutionHeader: setEndReviewExecutionHeader,

			getReviewList: getReviewList,

			setDetailsHeader                 : setDetailsHeader,
			normalizeActivity                : normalizeActivity,
			setNullHours                     : setNullHours,
			setStudentAttentionData          : setStudentAttentionData,
			formatSubjectActivity            : formatSubjectActivity,
			routeDetails                     : routeDetails,
			getActivityDetails               : getActivityDetails,
			submoduleItemRequired            : submoduleItemRequired,
			validateItems                    : validateItems,
			showModalItemRequiredEndPlanning : showModalItemRequiredEndPlanning,
			showModalItemRequiredEndExecution: showModalItemRequiredEndExecution,
			getItemsRequiredList             : getItemsRequiredList,
			showModalEndPlannig              : showModalEndPlannig,
		}
	}

}

Requests.$inject = [ 'Ramda' ]
export default angular.module('services.Requests', []).service('Requests', Requests).name



// WEBPACK FOOTER //
// ./src/app/u-faculty/lib/requests.js